import { inject, Injectable } from '@angular/core';
import {
  DefaultLocaleConfig,
  LOCALE_CONFIG,
  LocaleConfig,
} from '../utils/daterangepicker-locale-config';

@Injectable({
  providedIn: 'root',
})
export class DaterangepickerLocaleService {
  private _config = inject<LocaleConfig>(LOCALE_CONFIG);

  get config() {
    if (!this._config) {
      return DefaultLocaleConfig;
    }
    return { ...DefaultLocaleConfig, ...this._config };
  }
}
